import { Link, useNavigate } from "react-router-dom";
import { useTheme } from "@mui/styles";
import { useTranslation } from "react-i18next";
import React from "react";
import './styles/Shipping.css'
import ContainedButton from "../../components/Buttons/ContainedButton";

const ShippingColumn2 = () => {

  const { t } = useTranslation();
  const theme = useTheme();
  let navigate = useNavigate();

  return (
    <div className="col-6 shipping-col shipping-col-1">
      <div
        style={{
          width: "100%",
          color: theme.COLORS.BLUE.darkBlueGreen,
          fontSize: "2rem",
          marginTop: "5vh",
        }}
      >
        {t("Shipping to Major Centres")}
      </div>
      <div
        style={{
          width: "60%",
          color: theme.COLORS.BLUE.darkBlueGreen,
          fontSize: "1.3rem",
          marginTop: "1vh",
          marginBottom: "2vh",
        }}
      >
        {t(
          "We offer free shipping with White Glove Delivery, and Mattress recycling* to major Canadian centers with an approximate 10 day timeline to delivery."
        )}
      </div>
      <div className="row">
        <div className="col-5">
          <li
            style={{
              color: theme.COLORS.BLUE.darkBlueGreen,
              fontSize: "1.3rem",
            }}
          >
            {t("Lower Mainland (Vancouver)")}
          </li>
          <li
            style={{
              color: theme.COLORS.BLUE.darkBlueGreen,
              fontSize: "1.3rem",
            }}
          >
            {t("Calgary")}
          </li>
          <li
            style={{
              color: theme.COLORS.BLUE.darkBlueGreen,
              fontSize: "1.3rem",
            }}
          >
            {t("Edmonton")}
          </li>
        </div>
        <div className="col-4">
          <li
            style={{
              color: theme.COLORS.BLUE.darkBlueGreen,
              fontSize: "1.3rem",
            }}
          >
            {t("Winnipeg")}
          </li>
          <li
            style={{
              color: theme.COLORS.BLUE.darkBlueGreen,
              fontSize: "1.3rem",
            }}
          >
            {t("GTA (Toronto)")}
          </li>
          <li
            style={{
              color: theme.COLORS.BLUE.darkBlueGreen,
              fontSize: "1.3rem",
            }}
          >
            {t("Ottawa")}
          </li>
          <li
            style={{
              color: theme.COLORS.BLUE.darkBlueGreen,
              fontSize: "1.3rem",
            }}
          >
            {t("Montreal")}
          </li>
        </div>
        <div
          style={{
            width: "100%",
            color: theme.COLORS.BLUE.darkBlueGreen,
            fontSize: "2rem",
            marginTop: "5vh",
          }}
        >
          {t("Shipping Outside of Major Centres")}
        </div>
        <div
          style={{
            width: "70%",
            color: theme.COLORS.BLUE.darkBlueGreen,
            fontSize: "1.3rem",
            marginTop: "2vh",
            marginBottom: "2vh",
          }}
        >
          {t(
            "Our Service Experts will contact you to arrange Curbside LTL as there will be an additional charge. We will cover the base price of shipping to a major center near you."
          )}
        </div>
      </div>
      <div className="row mt-4 btn-group">
        {/*<Link*/}
        {/*  to={""}*/}
        {/*  style={{*/}
        {/*    color: theme.COLORS.WHITE.backgroundWhite,*/}
        {/*    textDecoration: "none",*/}
        {/*    width: "auto",*/}
        {/*  }}*/}
        {/*>*/}
        <ContainedButton
          className="col-auto"
          styles={{ width: "8vw" }}
          onClick={() => navigate("/contact-us")}
        >
          {t("CONTACT US")}
        </ContainedButton>
        {/*</Link>*/}
        {/*<Link*/}
        {/*  to={""}*/}
        {/*  style={{*/}
        {/*    color: theme.COLORS.WHITE.backgroundWhite,*/}
        {/*    textDecoration: "none",*/}
        {/*    width: "auto",*/}
        {/*  }}*/}
        {/*>*/}
        <ContainedButton
          className="col-auto"
          color={theme.COLORS.BLUE.backgroundBlue}
          fontColor={theme.COLORS.BLUE.darkBlueGreen}
          variant="outlined"
          onClick={() => navigate("/contact-us")}
        >
          {t("CALL US")}
        </ContainedButton>
        {/*</Link>*/}
      </div>
      <div
        style={{
          borderRadius: "0px 60px 0px 60px",
          width: 173,
          height: 158,
          borderWidth: "3px",
          borderStyle: "solid",
          borderColor: theme.COLORS.GREEN.green,
          marginTop: "-35px",
          marginLeft: "380px",
          opacity: 0.25,
        }}
      />
      <div
        style={{
          background: "#ABE1FA",
          borderRadius: "60px 0px 0px 0px",
          marginLeft: "480px",
          marginTop: "-95px",
          width: "350px",
          height: "160px",
          opacity: 0.35,
          zIndex: 100,
          boxShadow: "4px 4px 0px #005DFF0F",
        }}
      ></div>
      <div
        style={{
          width: "70%",
          color: theme.COLORS.BLUE.darkBlueGreen,
          fontSize: 10,
          marginTop: "-9vh",
          marginBottom: "2vh",
        }}
      >
        {t(
          "*Recycling includes a single mattress set. Recycling isn't always available outside of major centres."
        )}
      </div>
    </div>
  );
};

export default ShippingColumn2;
